export class DropdownOption {
  constructor(
    public displayName: string,
    public value: string,
    public disabled?: boolean
  ) {}
}
